import React from "react";
import LogoImage from "./logo.png";

export const Logo: React.FC = () => {
  return (
    <img
      src={LogoImage}
      alt="Mindsculpt Interactive Logo"
      style={{ maxWidth: 800, width: "100%" }}
    />
  );
};
